<div *ngIf="!loginDisplay">
  <div class="background">
    <div class="login-in-image">
      <button class="login-button" (click)="loginRedirect()">Login as Internal user</button>
    </div>
  </div>
</div>

<div class="layout-container" *ngIf="loginDisplay">
  <app-tool-bar (toggleSidenav)="toggleSidenav()" (toggleRightSidenav)="toggleRightSidenav()"
    (loginRedirect)="loginRedirect()"></app-tool-bar>

  <mat-sidenav-container id="leftSideNavContainer" class="left-sidenav-container" [autosize]="true">
    <mat-sidenav #leftSideNav class="left-sidenav" [class.rail]="collapsed"
      [mode]="mobileQuery.matches ? 'over' : 'side'" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56">
      <div class="sidebar-shell">
        <div class="sidebar-body">
          <div class="sidebar-scroll">
            <div class="sidebar-section">
              <div>
                <ng-container *ngFor="let item of navData">
                  <ng-container
                    *ngTemplateOutlet="recursiveList; context: { $implicit: item, level: 0 }"></ng-container>
                </ng-container>
              </div>
            </div>

            <div class="sidebar-divider" *ngIf="selectedRecord"></div>

            <div class="sidebar-section" *ngIf="selectedRecord">
              <div class="sidebar-section__label">Activity</div>
              <button type="button" class="sidebar-item sidebar-item--group"
                [attr.aria-expanded]="isDynamicSectionExpanded" [class.expanded]="isDynamicSectionExpanded" (click)="toggleDynamicSection()">
                <div class="sidebar-item__prefix">
                  <mat-icon>folder</mat-icon>
                </div>
                <div class="sidebar-item__content">
                  <span class="sidebar-item__title">{{ selectedRecord.activityNumber }}</span>
                  <span class="sidebar-item__subtitle" *ngIf="selectedRecord.propertyName">{{
                    selectedRecord.propertyName }}</span>
                </div>
                <mat-icon class="sidebar-item__chevron">chevron_right</mat-icon>
              </button>

              <div class="sidebar-sublist" [class.expanded]="isDynamicSectionExpanded">
                <button type="button" class="sidebar-subitem" *ngFor="let section of selectedRecordSections"
                  [ngClass]="{ active: selectedSubsection === section }" (click)="selectSection(section)">
                  {{ section }}
                </button>

                <button type="button" class="sidebar-subitem" [ngClass]="{ active: selectedSubsection === 'Comparables' }"
                  (click)="selectSection('Comparables')">
                  Comparables
                </button>

                <button type="button" class="sidebar-subitem" [ngClass]="{ active: selectedSubsection === 'Argus' }"
                  (click)="selectSection('Argus')">
                  Argus
                </button>

                <button type="button" class="sidebar-subitem"
                  [ngClass]="{ active: selectedSubsection === 'ChangeHistory' }"
                  (click)="selectSection('ChangeHistory')">
                  Change History
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav>

    <mat-sidenav-content class="mat-drawer-content">
      <main class="main">
        <div class="content-container">
          <router-outlet></router-outlet>
        </div>
      </main>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<ng-template #recursiveList let-item let-level="level">
  <div class="sidebar-node" [attr.data-level]="level">
    <!-- LEAF -->
    <button *ngIf="!item.children" type="button" class="sidebar-item" [class.sidebar-item--child]="level > 0"
      [class.sidebar-item--leaf]="true" [ngClass]="{ active: router.isActive(item.route, true) }"
      [routerLink]="item.route" (click)="clearSelectedRecord()" matTooltipShowDelay="350">
      <div class="sidebar-item__prefix">
        <mat-icon>{{ item.iconImage }}</mat-icon>
      </div>

      <span class="sidebar-item__label" *ngIf="!collapsed || level > 0" [title]="item.title">{{ item.title }}</span>

      <!-- Optional badge -->
      <span class="sidebar-item__badge" *ngIf="item.badgeCount && (!collapsed || level>0)">{{ item.badgeCount }}</span>
    </button>

    <!-- BRANCH -->
    <div *ngIf="item.children" class="sidebar-branch" [attr.data-level]="level">
      <button type="button" class="sidebar-item" [class.sidebar-item--child]="level > 0"
        [class.expanded]="isExpanded(item, level)" (click)="toggleItem(item, level)" matTooltipShowDelay="350">
        <div class="sidebar-item__prefix">
          <mat-icon>{{ item.iconImage }}</mat-icon>
        </div>

        <span class="sidebar-item__label" *ngIf="!collapsed || level > 0">{{ item.title }}</span>

        <mat-icon class="sidebar-item__chevron" *ngIf="!collapsed || level > 0">chevron_right</mat-icon>
      </button>

      <div class="sidebar-sublist" [class.expanded]="isExpanded(item, level)"
        [attr.aria-hidden]="!isExpanded(item, level)">
        <ng-container *ngFor="let child of item.children; trackBy: trackByTitle">
          <ng-container
            *ngTemplateOutlet="recursiveList; context: { $implicit: child, level: level + 1 }"></ng-container>
        </ng-container>
      </div>
    </div>
  </div>
</ng-template>

